<template>
    <el-dropdown @command="handleManual" style="padding-right: 10px;" v-if="list.length">
        <div style="cursor: pointer">
            <span class="userinfo-name text-black-50">
                <i class="el-icon-help"></i> 手册
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="x in list" :key="x.name" :icon="x.icon" :command="x.link" :divided="x.divided">
                {{ x.name }}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>

import {mapState} from "vuex";

export default {
    name: "user-manual",
    data() {
        return {
            list: [],
        }
    },
    computed: {
        ...mapState(['process', 'preset']),
    },
    methods: {
        handleManual(command) {
            window.open(command, "_blank");
        },
        loadManual(){
            this.$api('Admin.Manual.Manuals', {}, true).then(res => {
                this.list = [];
                let divided = false;
                let old = "";
                res.data.data.forEach(item => {
                    item.extra_link = item.extra_link?item.extra_link:"";
                    divided = ( old === "" && item.extra_link !== "");
                    old = item.extra_link;
                    this.list.push({icon: item.extra_link?'el-icon-link':'el-icon-ice-cream-square', divided: divided, name: item.name, link: item.extra_link?item.extra_link:item.link});
                });
            });
        }
    },
    mounted() {
    },
}
</script>

<style scoped>

</style>
